import { render, staticRenderFns } from "./AdvertisersApproveModalTemplate.vue?vue&type=template&id=59048fa4&scoped=true"
import script from "./AdvertisersApproveModalTemplate.vue?vue&type=script&lang=ts"
export * from "./AdvertisersApproveModalTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59048fa4",
  null
  
)

export default component.exports